import React, { useState, useEffect } from "react";
import InputSingle from "../../elements/input/InputSingle";
import SMSelect from "../../elements/select/SMSelect";
import styled from "styled-components";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
import { useParams } from "react-router-dom";
import axiosAPI from "../../utils/axios-api";
import SMModal from "../../elements/modals/SMModal";
import IsiKuesionerLiklert from "./IsiKuesionerLiklert";
import IsiKuesionerFile from "./IsiKuesionerFile";
import swal from 'sweetalert2';

const DivNumber = styled.div`
  display: grid;
  grid-template-columns: repeat(8, auto);
  grid-gap: 4px;
`;

const API = process.env.REACT_APP_API;

const IsiKuesioner = () => {
  let { idKuesioner } = useParams();
  const [dataUser, setdataUser] = useState({});
  const [dataKuesioner, setdataKuesioner] = useState({});
  const [dataPilihanGanda, setdataPilihanGanda] = useState([]);
  const [resultPilihanGanda, setresultPilihanGanda] = useState([]);
  const [tipeKuesioner, settipeKuesioner] = useState(null);
  const [kuesioner_id, setKuesionerId] = useState(0);

  // modal
  const [modalSave, setmodalSave] = useState(false);

  // loading PG
  const [loadingSubmitPG, setloadingSubmitPG] = useState(0);

  // data liklert
  const [dataLiklert, setdataLiklert] = useState([]);
  const [jenisLiklert, setjenisLiklert] = useState(null);
  const [skalaLiklert, setskalaLiklert] = useState([]);
  const [totalSoal, settotalSoal] = useState(0);

  // data file
  const [soalFile, setsoalFile] = useState(null);

  const [loadingGetSoal, setloadingGetSoal] = useState(false);

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    setdataUser(data);
    getDataKuesioner();
  }, []);

  function getDataKuesioner(params) {
    setloadingGetSoal(true);
    axiosAPI
      .get(API + "kuesioner/isi-kuesioner/" + idKuesioner + "?include=dataSoal")
      .then((res) => {
        setdataKuesioner(res.data.data);
        settipeKuesioner(res.data.data.tipe);
        setKuesionerId(res.data.data.id)

        if (res.data.data.tipe === 2) {
          setjenisLiklert(res.data.data.relationships.dataKategori);
          setskalaLiklert(res.data.data.relationships.dataSkala);
          // setdataLiklert(res.data.data.relationships.dataSoal)
        } else if (res.data.data.tipe === 1) {
          setsoalFile(res.data.data.relationships.dataSoal)
        }
        // setloadingGetSoal(false)
        getDataSoal();
      });
  }

  function getDataSoal(params) {
    // setloadingGetSoal(true)
    axiosAPI.get(API + "kuesioner/list-soal/" + idKuesioner).then((res) => {
      if (res.data.info_kuesioner.tipe === 0) {
        setdataPilihanGanda(res.data.data);
      } else if (res.data.info_kuesioner.tipe === 2) {
        setdataLiklert(res.data.data);
        settotalSoal(res.data.jumlah_soal)
      }
      setloadingGetSoal(false);
    });
  }

  function renderPilihanGanda() {
    function changePilihanGanda(params) {
      let { idx, val } = params;
      let data = resultPilihanGanda;
      data[idx] = val;
      setresultPilihanGanda(data);
    }
    return (
      <>
        <p className="text-blue-600 p-6">Pengisian jawaban kuesioner</p>
        <form action="">
          {dataPilihanGanda.map((val, idx) => {
            let pilihan = val.pilihan ?? {};
            return (
              <div key={idx} className="flex flex-col p-6">
                <div className="flex flex-row">
                  <div className="dark:text-gray-800">
                    <h1>{val.no_soal}</h1>
                  </div>
                  <div className="flex-1 flex flex-col px-4 dark:text-gray-800">
                    <div>
                      <p>{val.soal}</p>
                    </div>

                    <div className="flex flex-col">
                      <div className="flex flex-col" id={`PG-${val.no_soal}`}>
                        {!!pilihan
                          ? Object.keys(pilihan).map((val2, idx2) => {
                              return (
                                <label
                                  key={idx2}
                                  className="inline-flex items-center"
                                >
                                  <input
                                    type="radio"
                                    className="form-radio"
                                    name={`PG-${val.no_soal}`}
                                    id={`PG-${val.no_soal}`}
                                    onChange={() =>
                                      changePilihanGanda({
                                        idx: idx,
                                        val: val2,
                                      })
                                    }
                                  />
                                  <span className="ml-2">
                                    {val2}. {pilihan[val2] ?? ""}
                                  </span>
                                </label>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </form>
      </>
    );
  }

  function buttonSubmitPG(params) {
    return (
      <button
        onClick={() => setmodalSave(true)}
        className="py-2 px-4 text-white rounded bg-blue-500"
      >
        Submit
      </button>
    );
  }

  // submit based on type

  function submitPG(params) {
    let body = {
      jawaban: resultPilihanGanda,
    };
    setloadingSubmitPG(1);
    axiosAPI
      .post(API + "kuesioner/" + idKuesioner + "/kirim-jawaban", body)
      .then((res) => {
        if (res.data.status === "success") {
          swal.fire('Berhasil', params + ', ' + res.data.message, 'success');
          setloadingSubmitPG(2);
          window.location.replace("/partisipasi");
        } else {
          swal.fire('Gagal', params + ', ' + res.data.message, 'error');
          setloadingSubmitPG(2);
        }
      })
      .catch((err) => {
        setloadingSubmitPG(3);
      });
  }

  function konfirmasiScoin(){
    let body = {responden_id: idKuesioner, kuesioner_id: kuesioner_id, status: "berhasil"}
    
      axiosAPI
        .post(API + "scoin/konfirmasi", body)
        .then((res) => {
            submitPG(res.data.message)
        })
        .catch((xhr) => {
          console.log(xhr)
        });

  }

  // save based on type

  function savePG(params) {
    let pesan = null;
    let buttonSubmit = null;
    if (loadingSubmitPG === 0) {
      pesan = <p>Submit jawaban anda?</p>;
      buttonSubmit = (
        <button
          onClick={() => konfirmasiScoin()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Submit
        </button>
      );
    } else if (loadingSubmitPG === 1) {
      pesan = <p>Loading</p>;
      buttonSubmit = (
        <button className="px-4 py-2 rounded-lg bg-gray-20">Loading</button>
      );
    } else if (loadingSubmitPG === 2) {
      pesan = <p>Berhasil</p>;
      buttonSubmit = (
        <button
          onClick={() => {
            window.history.back();
          }}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Oke
        </button>
      );
    } else {
      pesan = <p>Gagal submit</p>;
      buttonSubmit = (
        <button
          onClick={() => submitPG()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Ulangi
        </button>
      );
    }

    if (resultPilihanGanda.length === dataPilihanGanda.length) {
      return (
        <div className="flex px-4">
          <div className="flex flex-col">
            {pesan}
            <div className="flex flex-row gap-2 my-4">
              {buttonSubmit}
              <button
                onClick={() => setmodalSave(false)}
                className="px-4 py-2 rounded-lg bg-gray-200"
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex px-4 py-4">
          <div className="flex flex-col">
            <p>Anda belum menjawab semua pertanyaan !!</p>
            <div className="flex flex-row gap-2"></div>
          </div>
        </div>
      );
    }
  }

  function renderModalSave(params) {
    return (
      <SMModal
        title="Submit Jawaban"
        show={modalSave}
        onClose={() => setmodalSave(!modalSave)}
      >
        {savePG()}
      </SMModal>
    );
  }

  function getTipe(tipe) {
    if( tipe === 0 ){
      return "Pilihan Ganda"
    }else if( tipe === 1 ){
      return "File"
    }else{
      return "Liklert"
    }
  }

  function downloadPanduan(file){

    let getFile = file.split("/").pop()
    let checkExt = getFile.slice((Math.max(0, getFile.lastIndexOf(".")) || Infinity) + 1)

    if(checkExt){
      return (
        <a href={file}>
          <button className="px-6 py-2 bg-blue-100 rounded-lg border border-blue-600">
            <h1 className="text-blue-600">Download Panduan</h1>
          </button>
        </a>
      );
    }

  }

  function renderType(params) {
    if (tipeKuesioner === 0) {
      return renderPilihanGanda();
    } else if (tipeKuesioner === 2) {
      return loadingGetSoal ? null : (
        <IsiKuesionerLiklert
          tipe={jenisLiklert}
          data={dataLiklert}
          skala={skalaLiklert}
          total={totalSoal}
          kuesioner_id={kuesioner_id}
          responden_id={idKuesioner}
        />
      );
    } else {
      return loadingGetSoal ? null : <IsiKuesionerFile dataSoal={soalFile} kuesioner_id={kuesioner_id} responden_id={idKuesioner} />;
    }
  }

  function _renderView(params) {
    return (
      <div
        className="w-full flex flex-row px-10 py-10 dark:text-white"
        style={{ minHeight: "100vh" }}
      >
        {renderModalSave()}
        <div className="w-5/12 flex flex-col pr-10">
          <p>Detail kuesioner {idKuesioner}</p>
          <h1 className="text-3xl font-bold">{dataKuesioner.judul}</h1>

          <p className="mt-4">{dataKuesioner.keterangan}</p>

          <div className="grid grid-flow-col auto-cols-max gap-4 my-6">
            <button className="px-6 py-2 bg-blue-100 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">
                {getTipe(dataKuesioner.tipe ?? "")}
              </h1>
            </button>
            {downloadPanduan(dataKuesioner.file_panduan ?? "")}
          </div>

          <div className="flex-col">
            <p>Nama Partisipan</p>
            <h1 className="font-bold text-2xl text-blue-500">
              {dataUser.nama}
            </h1>
          </div>

          <div className="flex flex-row my-4 items-center justify-between">
            <button
              className="flex flex-row gap-4"
              onClick={() => window.history.back()}
            >
              <ChevronLeftIcon className="w-6 h-6" />
              Kembali
            </button>

            {tipeKuesioner === 0 ? buttonSubmitPG() : null}
          </div>
        </div>

        <div
          className="w-7/12 bg-gray-200 rounded-lg"
          style={{
            maxHeight: "95vh",
            overflowY: "scroll",
          }}
        >
          {renderType()}
        </div>
      </div>
    );
  }

  return _renderView();
};

export default IsiKuesioner;
